import React from "react";
import { Row, Col } from "react-bootstrap";
import { sanitizeCkEditorHtml } from "configs";
import { formatAppraisalScoreDisplay } from "pages/AppraisalManagment/utils/appraisalAverageRating";
import { formatMaxRatingLabel } from "pages/AppraisalManagment/utils/myPafHelpers";
import "../../../Appraisal/AppraisalProgress.css";

const ACTUAL_RESULT_LABEL = "Comments";

const isIndividualObjectivesSection = (sectionTitle = "") =>
  String(sectionTitle).replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim().toLowerCase() ===
  "individual objectives";

const stripHtmlText = (html) =>
  String(html || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

const hasReadableDescription = (description) => stripHtmlText(description).length > 0;

const sanitizeDescriptionHtml = (html) => {
  if (!html || typeof html !== "string") return "";
  return sanitizeCkEditorHtml(html)
    .replace(/<script\b[\s\S]*?<\/script>/gi, "")
    .replace(/<iframe\b[\s\S]*?<\/iframe>/gi, "")
    .replace(/\s(on\w+)\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "");
};

const SetupQuestionDescription = ({ description }) => {
  const cleaned = sanitizeDescriptionHtml(description);
  if (!hasReadableDescription(cleaned)) return null;

  return (
    <Row>
      <Col lg={12}>
        <div
          className="setup-question-description mb-3"
          dangerouslySetInnerHTML={{
            __html: cleaned,
          }}
        />
      </Col>
    </Row>
  );
};

const MyPafScoreSections = ({ sectionCategories = {} }) => {
  const sectionTitles = Object.keys(sectionCategories || {});

  if (!sectionTitles.length) {
    return <p className="text-muted mb-0">No scoring sections available.</p>;
  }

  return (
    <div>
      {sectionTitles.map((sectionTitle) => {
        const rows = sectionCategories[sectionTitle] || [];
        const usesActualResultLayout = isIndividualObjectivesSection(sectionTitle);
        return (
          <div key={sectionTitle} className="mb-4">
            <h6 className="font-14 font-weight-bold heading-color mb-3">{sectionTitle}</h6>
            {rows.map((row, index) => (
              <div key={row.id || `${sectionTitle}-${index}`} className="appraisal-question-row mb-3">
                <div className="appraisal-question-body expanded">
                  <div className="appraisal-question-body-inner">
                    <p className="font-13 font-weight-s-bold heading-color mb-3">
                      {row.title || `Question ${index + 1}`}
                    </p>
                    <Row>
                      <Col lg={4}>
                        <p className="label-input mb-1">Weightage</p>
                        <p className="font-13 text-color mb-0">{row.weightage ?? "—"}</p>
                      </Col>
                      <Col lg={4}>
                        <p className="label-input mb-1">Max Rating</p>
                        <p className="font-13 text-color mb-0">{formatMaxRatingLabel(row.rating)}</p>
                      </Col>
                      <Col lg={4}>
                        <p className="label-input mb-1">Obtained Rating</p>
                        <p className="font-13 text-color mb-0">
                          {formatAppraisalScoreDisplay(row.obtained_score ?? row.obtained_rating)}
                        </p>
                      </Col>
                    </Row>
                    <SetupQuestionDescription description={row.description} />
                    <Row>
                      <Col lg={12}>
                        <p className="label-input mb-1">
                          {usesActualResultLayout ? ACTUAL_RESULT_LABEL : "Comments"}
                        </p>
                        <p className="font-13 text-color mb-0" style={{ whiteSpace: "pre-wrap" }}>
                          {row.comments && String(row.comments).trim() !== "" ? row.comments : "—"}
                        </p>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default MyPafScoreSections;
